import Vue from 'vue'
import VueRouter from 'vue-router'

import HomeView from '../views/Home/index.vue'
import RegisterView from '../views/Register/index.vue'
import LoginView from '../views/Login/index.vue'

import MineView from '../views/MyShop/index.vue'
import EditUsrInfoView from '../views/MyShop/editinf.vue'
import CertificationView from '../views/MyShop/certification.vue'
import MineWalletView from '../views/MyShop/wallet.vue'
import MineSellerView from '../views/MyShop/seller.vue'


import MyProCartView from '../views/MyShop/mycart.vue'
import DiscountedView from '../views/Discounted/index.vue'
import DiscountedNewView from '../views/Discounted/index1.vue'
import DiscountItemInfoView from '../views/Discounted/info.vue'


import ShopView from '../views/Shop/index.vue'
import ShopProductView from '../views/MyShop/editproduct.vue'
import ProductView from '../views/Product/index.vue'



import MaintainView from '../views/Maintain/index.vue'


import AboutUsView from '../views/AboutUs/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/maintain',
    name: 'maintain',
    component: MaintainView,
    meta: {
      title: '维护中',
      requireAuth: false
    }
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: '首页',
      requireAuth: false
    }
  },
  {
    path: '/aboutus',
    name: 'aboutus',
    component: AboutUsView,
    meta: {
      title: '关于我们',
      requireAuth: false
    }
  },
  {
    path: '/product',
    name: 'product',
    component: ProductView,
    meta: {
      title: '商品详情',
      requireAuth: false
    }
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView,
    meta: {
      title: '注册',
      requireAuth: false
    }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      title: '登录',
      requireAuth: false
    }
  },
  {
    path: '/mine',
    name: 'mine',
    component: MineView,
    meta: {
      title: '我的商铺',
      requireAuth: true
    }
  },
  {
    path: '/mycart',
    name: 'mycart',
    component: MyProCartView,
    meta: {
      title: '捡漏商品',
      requireAuth: true
    }
  },
  {
    path: '/discountedtmp',
    name: 'discountedtmp',
    component: DiscountedView,
    meta: {
      title: '捡漏宝贝tmp',
      requireAuth: true
    }
  },
  {
    path: '/discounted',
    name: 'discounted',
    component: DiscountedNewView,
    meta: {
      title: '捡漏宝贝',
      requireAuth: true
    }
  },
  
  {
    path: '/discountinf',
    name: 'discountinf',
    component: DiscountItemInfoView,
    meta: {
      title: '捡漏宝贝',
      requireAuth: true
    }
  },
  {
    path: '/editusr',
    name: 'editusr',
    component: EditUsrInfoView,
    meta: {
      title: '编辑账号资料',
      requireAuth: true
    }
  },
  {
    path: '/certification',
    name: 'certification',
    component: CertificationView,
    meta: {
      title: '商家身份认证',
      requireAuth: true
    }
  },
  {
    path: '/wallet',
    name: 'wallet',
    component: MineWalletView,
    meta: {
      title: '我的钱包',
      requireAuth: true
    }
  },
  {
    path: '/seller',
    name: 'seller',
    component: MineSellerView,
    meta: {
      title: '店铺设置',
      requireAuth: true
    }
  },
  {
    path: '/shoppro',
    name: 'shoppro',
    component: ShopProductView,
    meta: {
      title: '商品管理',
      requireAuth: true
    }
  },
  {
    path: '/shop',
    name: 'shop',
    component: ShopView,
    meta: {
      title: '店铺',
      requireAuth: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    // 核心配置：返回顶部坐标
    return new Promise((resolve) => {
      // 支持异步滚动 (如数据加载完成后)
      setTimeout(() => {
        resolve({ x: 0, y: 0, behavior: 'instant' })
      }, 50)
    })
  }
})

router.beforeEach((to, from, next) => {
  const nearestTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta?.title);
    let webName = ''
    
  if (to.params.id && nearestTitle) {
    document.title = webName + `${nearestTitle.meta.title} `;
  } else {
    document.title = webName + nearestTitle?.meta.title || '';
  }
  
  next();
});

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
